// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3nKqY","notes":"Notes_notes__2bo2m"};